// extracted by mini-css-extract-plugin
module.exports = {"Buttom":"pagen_Buttom__pC54p","Pagen":"pagen_Pagen__9EWX7","Current":"pagen_Current__N5GcG"};